import { create } from 'zustand'

interface ModalState {
   isMapStageModalOpen: boolean
   edit: boolean
   openMapStageModal: (edit?: boolean) => void
   closeMapStageModal: () => void
}

export const useMapStageStore = create<ModalState>((set) => ({
   isMapStageModalOpen: false,
   edit: false,
   openMapStageModal: (isFromEdit = false) =>
      set({
         isMapStageModalOpen: true,
         edit: isFromEdit,
      }),
   closeMapStageModal: () =>
      set({
         isMapStageModalOpen: false,
         edit: false,
      }),
}))
